import React, { useEffect, useCallback } from 'react';
import Alert from 'react-bootstrap/Alert';
import styled from 'styled-components';
import { wh, fontSize } from '../mixins';
import { useSelector, useDispatch } from 'react-redux';
import { setError, selectError } from '../features/error/errorSlice';
import { useTranslation } from 'react-i18next';


const StyledAlert = styled(Alert)`
  position: fixed;
  ${wh('90%', 'auto')};
  max-width: 327px;
  left: 50%;
  top: 6%;
  transform: translate(-50%, -20%);
  min-height: 50px;
  background-color: #FF5B5B;
  border-radius: 8px;
  padding: 16px 40px 16px 16px;
  border: none;
  z-index: 100;
    
  p {
    margin: 0;
    ${fontSize(14)};
    line-height: 18px;
    color: #fff;
    font-weight: 300;
    letter-spacing: -0.2px;
  }
    
  button.close {
    opacity: 1;
    ${wh('24px')};
    padding: 0;
    top: 50%;
    right: 16px;
    margin-top: -12px;
    
    &:focus {
      outline: none;
    }
  }
    
  span {
    color: #fff;
    box-shadow: none;
    font-weight: 400;
    text-shadow: none;
  }
`;


const UIAlert = () => {
  const error = useSelector(selectError);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const clearError = useCallback(() => dispatch(setError({show: false, text: '', type: ''})), [dispatch]);

  const doesEmailExist =
    error &&
    error.text &&
    (typeof error.text === 'string') &&
    (error.text.replace('.','').toLowerCase() === 'the email has already been taken');

  useEffect(() => {
    if (error.show) {
      setTimeout(clearError, 3000);
    }
  }, [error, clearError]);

  return (
    <StyledAlert show={error.show} onClose={clearError} variant="danger" dismissible={true}>
      <p>{doesEmailExist ? t('email_exist') : error.text}</p>
    </StyledAlert>
  )
};

export default UIAlert;